import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "icon"]
  static values = {
    expanded: Boolean
  }

  connect() {
    this.render()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.render()

    window.dispatchEvent(new Event("embed:content-resized"))
  }

  render() {
    const expanded = this.expandedValue

    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.toggle("hidden", !expanded)
    }

    if (this.hasIconTarget) {
      this.iconTarget.textContent = expanded ? "-" : "+"
    }
  }
}
